import '@/styles/index.less';
import init from '../init';
import App from './App.vue';

const routes = [
  {
    path: '/',
    component: App,
    meta: {
      title: ' '
    }
  }
];

init(routes);
